module.exports = __webpack_public_path__ + "static/01-a838b6d07677be08dbf16cb0db797aed.jpg";